import React, { useState } from "react";
import "./Square.scss";
import Button from "components/CustomButton/CustomButton";
import { ControlLabel, FormGroup } from "react-bootstrap";
import SettingsInput from "components/Settings/SettingsInput";
import { updateSquareInfo } from "services/square/square.service";

function SquareSyncCustomers(props) {
  const { goToNextStep } = props;
  const [form, setForm] = useState({
    squareSyncCustomers: true
  });
  const toggleChecked = event => {
    setForm({ ...form, [event.target.name]: event.target.checked });
  };
  const nextStep = () => {
    const configs = {
      squareSyncCustomers: form.squareSyncCustomers,
      squareLinked: true
    };
    updateSquareInfo(configs);
    goToNextStep(configs);
  };
  return (
    <div className="square-modal">
      <div className="square-modal__header">Sync your customers?</div>
      <div className="square-modal__body">
        <p>
          As you add names and phone numbers to your Waitly watilist, would you like automatically add them as Customer
          in your square account?{" "}
        </p>
        <div className="square-modal__toggle">
          <FormGroup style={{ margin: 0 }}>
            <ControlLabel style={{ float: "left", marginTop: 17, fontSize: 15 }}>Add Customers to Square</ControlLabel>
            <SettingsInput
              form={form}
              name={"squareSyncCustomers"}
              type={"switch"}
              enabled={true}
              style={{ marginBottom: 0 }}
              value={form.squareSyncCustomers}
              register={null}
              onChangeValue={toggleChecked}
            />
          </FormGroup>
        </div>
      </div>
      <div className="square-modal__footer square-modal__footer--right">
        <Button onClick={nextStep} bsStyle="info" className="square-modal__button btn-fill" pullRight type="button">
          Next
        </Button>
      </div>
    </div>
  );
}

export default SquareSyncCustomers;
